import { TextareaHTMLAttributes } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    // value?: string,
    label?: string,
    dataMessage?: string,
    dataTestId?: string,
    error?: string,
}

function TextArea({ value, label, placeholder, required, dataTestId, error, ...props }: TextAreaProps) {
    return (
        <p className="form__item">
            <label htmlFor="" className="form__label">{label}</label>
            <textarea
                className={'form__input' + ((error && (!value && required)) ? ' _error' : '')}
                data-test-id={dataTestId}
                value={value}
                required={required}
                placeholder={placeholder}
                {...props}
            />
            {(error && (!value && required)) && <span className="form__input-error-message">{error}</span>}
        </p>
    );
}

export default TextArea;